import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { Pizza, LogIn, Eye, EyeOff } from 'lucide-react';

export default function UserLoginPage() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPw, setShowPw] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    const result = await login(email, password);
    if (result.success) {
      navigate('/dashboard');
    } else {
      setError(result.error);
    }
    setLoading(false);
  };

  return (
    <div className="min-h-screen bg-[#FFF8E7] flex items-center justify-center p-4">
      <div className="pizza-card p-6 sm:p-8 w-full max-w-sm" data-testid="user-login-card">
        <div className="text-center mb-6">
          <div className="w-14 h-14 bg-[#E23D28] rounded-full border-2 border-[#2A2A2A] flex items-center justify-center mx-auto mb-3 shadow-[3px_3px_0px_0px_rgba(42,42,42,1)]">
            <Pizza className="w-7 h-7 text-white" />
          </div>
          <h1 className="text-3xl text-[#2A2A2A]" style={{ fontFamily: "'Bebas Neue', cursive" }} data-testid="user-login-title">
            Welcome Back
          </h1>
          <p className="text-sm text-[#2A2A2A]/50 mt-1">Sign in to access your saved data.</p>
        </div>

        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="text-xs uppercase tracking-wider text-[#2A2A2A]/60 mb-0.5 block" style={{ fontFamily: "'Bebas Neue', cursive" }}>Email</label>
            <input type="email" required value={email} onChange={e => setEmail(e.target.value)}
              placeholder="mike@pizzapalace.com" className="pizza-input w-full" data-testid="user-login-email" />
          </div>
          <div>
            <label className="text-xs uppercase tracking-wider text-[#2A2A2A]/60 mb-0.5 block" style={{ fontFamily: "'Bebas Neue', cursive" }}>Password</label>
            <div className="relative">
              <input type={showPw ? 'text' : 'password'} required value={password} onChange={e => setPassword(e.target.value)}
                placeholder="Enter password" className="pizza-input w-full pr-10" data-testid="user-login-password" />
              <button type="button" onClick={() => setShowPw(!showPw)}
                className="absolute right-3 top-1/2 -translate-y-1/2 text-[#2A2A2A]/40 hover:text-[#2A2A2A]">
                {showPw ? <EyeOff className="w-4 h-4" /> : <Eye className="w-4 h-4" />}
              </button>
            </div>
          </div>
          {error && <p className="text-sm text-[#E23D28]" data-testid="user-login-error">{error}</p>}
          <button type="submit" disabled={loading}
            className="pizza-btn w-full flex items-center justify-center gap-2 disabled:opacity-50"
            data-testid="user-login-submit">
            {loading ? 'Signing in...' : <><LogIn className="w-4 h-4" /> Sign In</>}
          </button>
          <Link to="/forgot-password" className="block text-center text-sm text-[#E23D28] hover:underline" data-testid="forgot-password-link">
            Forgot your password?
          </Link>
          <p className="text-center text-sm text-[#2A2A2A]/50">
            Don't have an account?{' '}
            <Link to="/register" className="text-[#E23D28] hover:underline font-medium" data-testid="user-login-register-link">
              Create one free
            </Link>
          </p>
          <Link to="/wizard" className="block text-center text-xs text-[#2A2A2A]/40 hover:text-[#E23D28]">
            Or try the calculator without an account
          </Link>
        </form>
      </div>
    </div>
  );
}
